import $ from 'jquery';
$(function() {
    let $window = $(window);
    let $body = $("body");
    let $header = $("header.header");

    //------------------------------------------------
    // Goto country page
    $(".country-header-item-input").on('click', (e)=>{
        window.location.href = $(e.currentTarget).val(); 
    });

    $(".country-header-item-input").on('click', function() {
            var $box = $(this);
            if ($box.is(":checked")) {
            var group = "input:checkbox[name='" + $box.attr("name") + "']";
            $(group).prop("checked", false);
            $box.prop("checked", true);
            } else {
            $box.prop("checked", false);
            }
    });

    //------------------------------------------------
    // Change language 
    $(".language-header-item-input").on('click', (e)=>{
        window.location.href = $(e.currentTarget).val(); 
    });

    $(".language-header-item-input").on('click', function() {
        var $box = $(this);
        if ($box.is(":checked")) {
        var group = "input:checkbox[name='" + $box.attr("name") + "']";
        $(group).prop("checked", false);
        $box.prop("checked", true);
        } else {
        $box.prop("checked", false);
        }
    });
    //------------------------------------------------
    // Search

    $("header .cta-search").click(()=>{
       $("header.header").addClass("open-search");
       $("header.header .searchform input").focus();
    });

    $("header .cta-erase").click(()=>{
       $("header.header").removeClass("open-search");
    });

    //------------------------------------------------
    // Scroll

    function onScroll(){
        let scrollTop = $window.scrollTop();
        $header.toggleClass("reverse sticky", scrollTop > 50);
    } 
    
    $window.scroll(() => {
        onScroll();
    });
    
    //------------------------------------------------
    // Toggle mobile menu

    $(".burger-menu").click(()=>{
        $body.toggleClass("open-sidebar");
    });

    $(".mobile-overlay").click(()=>{
        $body.removeClass("open-sidebar");
    });

    $(".header .cta-close").click(()=>{
        $body.removeClass("open-sidebar");
    });

    //-----------------------------------------------
    // dropdown

    let $combobox = '[data-field-type="header-combobox"]';

    $.fn.dropdownList= function(){
        let $field = $(this);
        let $toggle = $field.find('[data-action="toggle"]');
        
        $toggle.on('click',function(e){
            let active = !$field.hasClass('active');
            e.preventDefault;
            $($combobox).removeClass('active');
            if(active){
                $field.addClass('active');
            }
            $(document).on('mouseup',function (e) {
                if ($(e.target).closest($field).length === 0) {
                    $field.removeClass('active');
                }
            });       
        })
    }

    $($combobox).each(function(){
        $(this).dropdownList();
    })
    //-----------------------------------------------
    // hover submenu
    $.fn.submenu = function (){
        let sub = $('.sub-menu');
        if ($(window).width() < 1025) {
            sub.hide();
            $('.menu-item-has-children a').unbind().on('click', function (e){
                $(this).next('.sub-menu').toggle().parent().toggleClass('toggled');
            })
        }
    }
    $('.menu-item-has-children').each(function(){
        $(this).submenu();
    })

    /***
     *  heamder menu JS
     * */
     
    // options you can change
    var deobfuscate_on_right_click = true;
    // function to open link on click
    function akn_ofbuscate_clicked($el,force_blank) {
        if (typeof(force_blank)=='undefined')
            var force_blank = false;
        var link = atob($el.data('o'));
        var _blank = $el.data('b');
        if (_blank || force_blank)
            window.open(link);
        else
            location.href = link;
    }
    // trigger link opening on click
    $(document).on('click','.akn-obf-link',function() {
        var $el = $(this);
        if (!$el.closest('.akn-deobf-link').length)
            akn_ofbuscate_clicked($el);
    });
    // trigger link openin in new tab on mousewheel click
    $(document).on('mousedown','.akn-obf-link',function(e) {
        if (e.which==2) {
            var $el = $(this);
            if (!$el.closest('.akn-deobf-link').length) {
                akn_ofbuscate_clicked($el,true);
                return true;
            }
        }
    });
    // deobfuscate link on right click so the context menu is a legit menu with link options
    $(document).on('contextmenu','.akn-obf-link',function(e) {
        if (deobfuscate_on_right_click) {
            var $el = $(this);
            if (!$el.closest('.akn-deobf-link').length) {
                e.stopPropagation();
                var link = atob($el.data('o'));
                var _blank = $el.data('b');
                $el.wrap('<a class="akn-deobf-link" href="'+link+'"'+(_blank?' target="_BLANK"':'')+'></a>').parent().trigger('contextmenu');
                setTimeout(function() {
                    $el.unwrap();
                },10);
            }
        }
    });
    
});